export default "__VITE_ASSET__BZok4Epy__"